import $ from 'jquery';

$('.search-toggle').on('click', function (e) {
    e.preventDefault();
    $.magnificPopup.open({
        items: {
            src: '#search-popup'
        },
        type: 'inline'
    });
});
